const authenticate = {
    computed:{
    pageTitle(){
        return this.Request && this.Request.Products?`${this.Request.ClientName} - ${this.Request.ClientID} | ${this.Request.Products.length} Products`:'';
       },
    },
    mounted() {
        if (!this.canApproveCurrentWorkflowRequest) {
            this.$router.push({
                name: "error",
                params: {
                    message: "UnAuthorized"
                },
            });
        } else {
            this.$store
                .dispatch("product/GetProductRequestWithTaskDetails", parseInt(this.id))
                .then((res) => {
                    this.Request = res.data;
                })
                .catch((err) => {
                    if (err.response && err.response.status == 403) {
                        this.$router.push({
                            name: "error",
                            params: {
                                message: "UnAuthorized"
                            },
                        });
                    }
                    else{
                        this.Error = true;
                        alert(err);
                    }
                });
        }
    }
};
export default authenticate;